import { render } from "./RoleGroupCard.vue?vue&type=template&id=fbf4212e"
import script from "./RoleGroupCard.vue?vue&type=script&lang=js"
export * from "./RoleGroupCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__